<header id="app-header" class="app-header">
	<div class="app-header-shell">
		<div class="app-header-row">
			<div class="app-header-logo-col">
				<div id="app-logo" class="app-logo-clickable" (click)="navigateToHome()" role="button" tabindex="0"
					(keydown.enter)="navigateToHome()" (keydown.space)="navigateToHome()">
					<div>
						<img class="app-logo-image" src="assets/image/FordProtect_Blue_RGB_Hz_v1.png"
							alt="Ford Protect - Clique para voltar à home">
					</div>
				</div>
			</div>

			<div class="app-header-controls app-header-controls-col">
				@if (isAccessManagement === true) {
				<div class="app-header-control">
					<label for="systemCountry">{{ 'TRANSLATE.COUNTRY.ORIGIN' | translate }} </label>
					<p-dropdown [(ngModel)]="selectedSystemCountry" [options]="systemCountries" [optionValue]="'value'"
						[placeholder]="'TRANSLATE.SELECT' | translate" [autoDisplayFirst]="false"
						panelStyleClass="app-header-dropdown-panel" [appendTo]="'body'" id="systemCountry"
						name="systemCountry" (onChange)="changeSystemCountry($event.value)">
						<ng-template pTemplate="item" let-item>
							<span class="app-dropdown-label"> {{ item?.label | translate }}</span>
						</ng-template>
						<ng-template let-item pTemplate="selectedItem">
							@if (item?.flag) {
							<img src="./../../../assets/image/{{item.flag}}.png" class="app-flag" alt="">
							}
							<span class="app-dropdown-label">
								{{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
							</span>
						</ng-template>
					</p-dropdown>
				</div>
				}

				<div class="app-header-control">
					<label for="lang">{{ 'TRANSLATE.COUNTRY.LANGUAGE' | translate }} </label>
					<p-dropdown [(ngModel)]="selectedLanguage" [options]="languages" [optionValue]="'value'"
						[placeholder]="'TRANSLATE.SELECT' | translate" [autoDisplayFirst]="false"
						panelStyleClass="app-header-dropdown-panel" [appendTo]="'body'" id="lang" name="lang"
						(onChange)="changeLang($event.value)">
						<ng-template pTemplate="item" let-item>
							<span class="app-dropdown-label"> {{ item?.label | translate }}</span>
						</ng-template>
						<ng-template let-item pTemplate="selectedItem">
							@if (item?.flag) {
							<img src="./../../../assets/image/{{item.flag}}.png" class="app-flag" alt="">
							}
							<span class="app-dropdown-label">
								{{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
							</span>
						</ng-template>
					</p-dropdown>
				</div>
			</div>
		</div>

		<app-nav class="app-header-nav"></app-nav>
	</div>
</header>